import { useMemo } from 'react'

export const Bars = ({ complexity }) => {
    const { one, two, three } = useMemo(() => {
        const inactive = 'var(--f-color-surface-strongest)'
        let one = inactive
        let two = inactive
        let three = inactive

        switch (complexity) {
            case 'low':
                one = 'var(--f-color-caution)'
                break
            case 'medium':
                one = 'var(--f-color-warning)'
                two = 'var(--f-color-warning)'
                break
            case 'high':
                one = 'var(--f-color-danger)'
                two = 'var(--f-color-danger)'
                three = 'var(--f-color-danger)'
                break
        }

        return { one, two, three }
    }, [complexity])

    return (
        <svg
            width="18px"
            height="18px"
            viewBox="0 0 25 25"
            xmlns="http://www.w3.org/2000/svg">
            <rect
                x="2"
                y="15"
                width="4"
                height="8"
                rx="1.5"
                fill={one}
            />
            <rect
                x="10"
                y="10"
                width="4"
                height="13"
                rx="1.5"
                fill={two}
            />
            <rect
                x="18"
                y="5"
                width="4"
                height="18"
                rx="1.5"
                fill={three}
            />
        </svg>
    )
}
